module.exports = __webpack_public_path__ + "img/loginimage.5c267e26.png";